import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../dataManagement/uiDb/UiDb";
import CreateProductConfigHelper from "../../../../../services/helpers/CreateProductConfigHelper";
import {
  ListingTypeConfig,
  ListingTypesMaster,
  SharedAttributeConfig,
} from "../../../../../interfaces/ProductObject";
import { CtaStrategy, buildCtaStrategy } from "../config/CtaStrategyConfig";

export interface UseListingTypeConfigResult {
  master: ListingTypesMaster;
  listingTypeId: string;
  listingTypeConfig: ListingTypeConfig | null;
  sharedAttributes: SharedAttributeConfig[];
  ctaStrategy: CtaStrategy;
}

export function useListingTypeConfig(listingTypeLabel: string | undefined): UseListingTypeConfigResult {
  const uiConfigurations = useSelector(
    (state: RootState) => state.general.uiConfigurations
  );

  const master = useMemo(
    () => CreateProductConfigHelper.getListingTypesMaster(uiConfigurations),
    [uiConfigurations]
  );

  const listingTypeId = useMemo(
    () => CreateProductConfigHelper.listingTypeLabelToId(listingTypeLabel ?? ""),
    [listingTypeLabel]
  );

  const listingTypeConfig = useMemo(
    () => CreateProductConfigHelper.getListingTypeConfig(master, listingTypeId),
    [master, listingTypeId]
  );

  const sharedAttributes = useMemo(
    () => CreateProductConfigHelper.getSharedAttributesForType(master, listingTypeId),
    [master, listingTypeId]
  );

  const ctaStrategy = useMemo(
    () => buildCtaStrategy(listingTypeConfig?.cta),
    [listingTypeConfig]
  );

  return { master, listingTypeId, listingTypeConfig, sharedAttributes, ctaStrategy };
}
